export default "__VITE_ASSET__DIlhtwMZ__"